(() => {

  const ROOT =
    document.documentElement;


  const STORAGE_KEY =
    'raftr-alt-theme';



  /* =========================================================
     THEME
     ========================================================= */

  function setTheme(
    mode,
    persist = true
  ) {

    const next =
      mode === 'dark'
        ? 'dark'
        : 'light';


    ROOT.setAttribute(
      'data-raftr-theme',
      next
    );


    if (persist) {

      try {

        localStorage.setItem(
          STORAGE_KEY,
          next
        );

      } catch (error) {}

    }


    document
      .querySelectorAll(
        '[data-raftr-theme-toggle]'
      )
      .forEach(
        (button) => {

          button.setAttribute(
            'aria-pressed',
            next === 'dark'
              ? 'true'
              : 'false'
          );


          button.setAttribute(
            'data-active-theme',
            next
          );


          button.setAttribute(
            'aria-label',
            next === 'dark'
              ? 'Switch to light mode'
              : 'Switch to dark mode'
          );

        }
      );


    const colorMeta =
      document.querySelector(
        '[data-raftr-theme-color]'
      );


    if (colorMeta) {

      colorMeta.setAttribute(
        'content',
        next === 'dark'
          ? '#1F1F1F'
          : '#FFFFFF'
      );

    }

  }



  /* =========================================================
     THEME TOGGLES
     ========================================================= */

  function initThemeToggles(
    scope = document
  ) {

    scope
      .querySelectorAll(
        '[data-raftr-theme-toggle]'
      )
      .forEach(
        (button) => {

          if (
            button.dataset.raftrBound ===
            'true'
          ) {
            return;
          }


          button.dataset.raftrBound =
            'true';


          button.addEventListener(
            'click',
            () => {

              const current =
                ROOT.getAttribute(
                  'data-raftr-theme'
                ) === 'dark'
                  ? 'dark'
                  : 'light';


              setTheme(
                current === 'dark'
                  ? 'light'
                  : 'dark'
              );

            }
          );

        }
      );


    setTheme(
      ROOT.getAttribute(
        'data-raftr-theme'
      ) === 'dark'
        ? 'dark'
        : 'light',
      false
    );

  }



  /* =========================================================
     MOBILE MENU
     ========================================================= */

  function initMenus(
    scope = document
  ) {

    scope
      .querySelectorAll(
        '[data-raftr-menu-toggle]'
      )
      .forEach(
        (button) => {

          if (
            button.dataset.raftrBound ===
            'true'
          ) {
            return;
          }


          button.dataset.raftrBound =
            'true';


          const header =
            button.closest(
              '[data-raftr-alt-header]'
            );


          if (!header) {
            return;
          }


          const drawer =
            header.querySelector(
              '[data-raftr-menu-drawer]'
            );


          const menuLabel =
            button.querySelector(
              '[data-raftr-menu-label]'
            );


          if (!drawer) {
            return;
          }


          function setOpen(
            open
          ) {

            button.setAttribute(
              'aria-expanded',
              open
                ? 'true'
                : 'false'
            );


            drawer.hidden =
              !open;


            header.classList.toggle(
              'is-menu-open',
              open
            );


            document.body.classList.toggle(
              'raftr-nav-open',
              open
            );


            if (menuLabel) {

              menuLabel.textContent =
                open
                  ? 'CLOSE'
                  : 'MENU';

            }

          }


          button.addEventListener(
            'click',
            () => {

              setOpen(
                button.getAttribute(
                  'aria-expanded'
                ) !== 'true'
              );

            }
          );


          drawer
            .querySelectorAll('a')
            .forEach(
              (link) => {

                link.addEventListener(
                  'click',
                  () => setOpen(false)
                );

              }
            );


          document.addEventListener(
            'keydown',
            (event) => {

              if (
                event.key === 'Escape' &&
                button.getAttribute(
                  'aria-expanded'
                ) === 'true'
              ) {

                setOpen(false);

                button.focus();

              }

            }
          );

        }
      );

  }



  /* =========================================================
     LOADER
     ========================================================= */

  function initLoader() {

    const loader =
      document.querySelector(
        '[data-raftr-loader]'
      );


    if (!loader) {

      document.body.classList.remove(
        'raftr-is-loading'
      );

      return;

    }


    const startedAt =
      performance.now();


    /*
     * RAFTR pops first.
     * Then the yellow square gets enough time
     * to visibly pulse before the page appears.
     */

    const minimumVisibleMs =
      1150;


    const maximumVisibleMs =
      2400;


    let dismissed =
      false;



    function dismissLoader() {

      if (dismissed) {
        return;
      }


      dismissed =
        true;


      const elapsed =
        performance.now() -
        startedAt;


      const remaining =
        Math.max(
          0,
          minimumVisibleMs -
          elapsed
        );


      window.setTimeout(
        () => {

          loader.classList.add(
            'is-leaving'
          );


          document.body.classList.remove(
            'raftr-is-loading'
          );


          window.setTimeout(
            () => {

              loader.hidden =
                true;

            },
            320
          );

        },
        remaining
      );

    }



    if (
      document.readyState ===
      'complete'
    ) {

      dismissLoader();

    } else {

      window.addEventListener(
        'load',
        dismissLoader,
        {
          once: true
        }
      );

    }


    /*
     * Fail-safe.
     * Never allow the loader to trap the page.
     */

    window.setTimeout(
      dismissLoader,
      maximumVisibleMs
    );

  }



  /* =========================================================
     INIT
     ========================================================= */

  function init(
    scope = document
  ) {

    initThemeToggles(
      scope
    );


    initMenus(
      scope
    );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        init();

        initLoader();

      },
      {
        once: true
      }
    );

  } else {

    init();

    initLoader();

  }



  document.addEventListener(
    'shopify:section:load',
    (event) => {

      init(
        event.target
      );

    }
  );

})();